import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import {
    FaPhp, FaLaravel, FaHtml5, FaCss3Alt, FaJs, FaReact, FaMobileAlt,
} from "react-icons/fa";
import { SiMysql, SiElectron } from "react-icons/si";
import "./style.css";
import { LeftContent, RightContent } from "../../global-components/src/components/screen/left-content";

export const technologies = [
    {
        title: "Laravel e PHP",
        icon: (
            <>
                <FaLaravel className="me-1 text-danger fs-3" />
                <FaPhp className="text-primary fs-3" />
            </>
        ),
        description: "Backend robusto com estrutura MVC moderna.",
    },
    {
        title: "MySQL",
        icon: <SiMysql className="text-primary fs-3" />,
        description: "Banco de dados relacional com performance e integridade.",
    },
    {
        title: "HTML/CSS",
        icon: (
            <>
                <FaHtml5 className="me-1 text-warning fs-3" />
                <FaCss3Alt className="text-info fs-3" />
            </>
        ),
        description: "Estrutura e estilo das páginas web.",
    },
    {
        title: "JavaScript",
        icon: <FaJs className="text-warning fs-3" />,
        description: "Interatividade e manipulação dinâmica do DOM.",
    },
    {
        title: "React Native",
        icon: (
            <>
                <FaReact className="me-1 text-info fs-3" />
                <FaMobileAlt className="text-success fs-3" />
            </>
        ),
        description: "App nativo multiplataforma com alto desempenho.",
    },
    {
        title: "Electron",
        icon: <SiElectron className="text-secondary fs-3" />,
        description: "Aplicativo de desktop com interface web.",
    },
    {
        title: "React",
        icon: <FaReact className="text-info fs-3" />,
        description: "Biblioteca moderna para interfaces web reutilizáveis.",
    },
];

const Tecnologies = () => {
    const siteUrl = "https://pacoca.net";
    const pageUrl = `${siteUrl}/blog/tecnologias`;

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: "As tecnologias por trás do Paçoca",
        description:
            "Laravel, PHP, MySQL, React, React Native e Electron — conheça a stack completa da rede social brasileira Paçoca.",
        url: pageUrl,
        author: {
            "@type": "Person",
            name: "João Enrique Barbosa Santos Alves",
        },
        publisher: {
            "@type": "Organization",
            name: "Paçoca Inc.",
            url: siteUrl,
        },
        inLanguage: "pt-BR",
        image: `${siteUrl}/img/link-preview.png?v=1`,
    };

    return (
        <>
          <LeftContent/>
          <RightContent/>
            <Helmet>
                <title>Tecnologias – Paçoca</title>
                <meta
                    name="description"
                    content="Conheça a stack técnica do Paçoca: Laravel, PHP, MySQL, React, React Native, Electron e JavaScript — a rede social 100% brasileira."
                />
                <meta
                    name="keywords"
                    content="tecnologias paçoca, stack paçoca, laravel, react native, rede social brasileira, programação paçoca"
                />
                <meta name="author" content="João Enrique Barbosa Santos Alves" />
                <link rel="canonical" href={pageUrl} />

                <meta property="og:type" content="article" />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:title" content="Tecnologias do Paçoca – Rede Social Brasileira" />
                <meta
                    property="og:description"
                    content="Laravel, PHP, MySQL, React, React Native e Electron — conheça a stack completa da rede social brasileira Paçoca."
                />
                <meta property="og:image" content={`${siteUrl}/img/link-preview.png?v=1`} />
                <meta property="og:locale" content="pt_BR" />
                <meta property="og:site_name" content="Paçoca" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Tecnologias do Paçoca – Rede Social Brasileira" />
                <meta
                    name="twitter:description"
                    content="Laravel, PHP, MySQL, React, React Native e Electron — conheça a stack do Paçoca."
                />
                <meta name="twitter:image" content={`${siteUrl}/img/link-preview.png?v=1`} />

                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <div className="blog-post-page">
                <article>
                    <div className="blog-post-eyebrow">
                        <Link to="/blog">Blog</Link>
                        <span aria-hidden="true">›</span>
                        <span>Tecnologia</span>
                    </div>

                    <h1 className="blog-post-title">As tecnologias por trás do Paçoca</h1>

                    <p className="blog-post-lead">
                        Uma stack pensada para escalar de forma independente — do backend ao app
                        mobile e desktop.
                    </p>

                    <hr className="blog-post-divider" />

                    <div className="tech-grid">
                        {technologies.map((tech, index) => (
                            <div className="tech-card" key={index}>
                                <div className="tech-icon-wrap">{tech.icon}</div>
                                <h5 className="tech-card-title">{tech.title}</h5>
                                <p className="tech-card-desc">{tech.description}</p>
                            </div>
                        ))}
                    </div>
                </article>
            </div>
        </>
    );
};

export default Tecnologies;